// src/features/dashboard/utils/monthlyProductivity.utils.ts

export const formatPercentage =
  (
    value: number,
  ) =>
    `${value.toFixed(1)}%`;

export const formatTrend =
  (
    value: number,
  ) =>
    `${value > 0 ? '▲' : '▼'} ${Math.abs(value).toFixed(1)}pp`;